import React from 'react';
import SVG from 'components/base/SVG';

import css from './style.scss';


const LoadingCellRenderer = () => (
  <div className={css.rowLoading}>
    <SVG icon="spinner" size={12} />
    <span>Loading</span>
  </div>
);

export default LoadingCellRenderer;
